<template lang="pug">
  #MissionsList
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 集點卡 > {{ activityName }}
    .container-width
      .p-3
        b-row.no-gutters.px-3(
          style="border-bottom: 0.2rem solid #000;"
        )
          b-col.px-2(
            cols=6
          )
            b-button(
              block,
              :variant=" nowSelectItem === 0 ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler(0)",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold;"
            ) 未達成
          b-col.px-2(
            cols=6
          )
            b-button(
              block,
              :variant=" nowSelectItem === 1 ? 'primary' : 'gray-light-3 text-black' ",
              @click="changeTypeHandler(1)",
              style="border-radius: .8rem .8rem 0 0;font-weight: bold;"
            ) 已達成
    .missionsInfo.p-3.mb-3.h-100
      b-card.border-0.mb-2.customerCard.word-break-all(
        no-body
        bg-variant="white",
        v-for="(item, index) in missionsList",
        @click="searchMemberHandler(item.point_collection_template_mission_id)"
      )
        .row.p-2
          .col-9.d-flex.align-items-center.pr-0
            span.font-weight-bold 任務{{index+1}}：{{ item.point_collection_template_mission_name }}
          .col-3.d-flex.align-items-center.justify-content-end
            i.fas.fa-user.mr-1.text-danger
            span.text-danger {{ item.member_count }}
      p.mb-0.p-3(
        v-if="missionsList.length === 0"
      ) 無集點活動
</template>

<script>
import { mapState } from 'vuex';
const _ = require('lodash');
import { SA_GROUP_PUSH_INDEX } from '@/router/sa/group-push';

export default {
  name: 'MissionsList',
  props: {
    activityId: {
      type: [String, Number],
    },
    activityName: {
      type: [String, Number],
    },
  },
  data() {
    return {
      nowSelectItem: 0,
    };
  },
  mounted() {
    const vm = this;
    !vm.activityId ? vm.$router.back() :vm.initHandler(0);
  },
  methods: {
    searchMember(activityId) {
      const vm = this;
      vm.$swal.fire({
        title: '搜尋中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      let apiData = {
          point_collection_template_mission_id: activityId,
          type: this.nowSelectItem,
          per_page: 999999,
          current_page: 1
      }
      vm.$store.dispatch('sa_points_card/getMemberListHandler', apiData).then((res) => {
        vm.$swal.close();
        vm.$store.commit('sa_group_push/setMemberList', res.data.members);
        vm.$router.push({
          name: SA_GROUP_PUSH_INDEX,
          params:{
            activity: 'points_card'
          },
        });
      });
    },
    initHandler(type) {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_points_card/getMissionsHandler', {type: type, point_collection_id: this.activityId})
        .then(() => {
          vm.$swal.close();
        });
    },
    searchMemberHandler(activityId) {
      this.$store.commit('sa_points_card/resetHandler');
      this.searchMember(activityId);
      //這裏要去我的會員
    },
    changeTypeHandler(type) {
      if(type === 0) {
        if(this.nowSelectItem === 0) return 
        this.nowSelectItem = 0;
        this.initHandler(0);
      }else{
        if(this.nowSelectItem === 1) return 
        this.nowSelectItem = 1;
        this.initHandler(1);
      }
    },
  },
  computed: {
    ...mapState({ 
      missionsList: (state) => state.sa_points_card.missionsList,
    })
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 0.2rem solid #000!important;
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}
</style>
